import { useEffect } from 'react';
import { useCartStore } from '@/stores/cartStore';

/**
 * Hook to sync cart state with Shopify
 * - Syncs on initial page load (handles browser refresh after checkout)
 * - Syncs when user returns to the tab (handles return from checkout in new tab)
 */
export function useCartSync() {
  const syncCart = useCartStore(state => state.syncCart);

  useEffect(() => {
    // Sync on initial page load
    syncCart();
    
    // Sync when user returns to the tab
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        syncCart();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [syncCart]);
}